<template>
  <div class="tabs-page">
    <div class="colors-wrapper">
      <div class="gradient"></div>
    </div>

    <ProjectHeader
      class="project-header"
      :class="{ hide: activePageIndex == 3 }"
      :style="`--header-height: -${headerHeight}px`"
      :project="project"
      :isFollowing="isFollowing"
      @toggleFollowProject="handleToggleFollowProject"
    />

    <div class="viewport">
      <div
        class="components-wrapper"
        :style="`--left-percentage: -${(activePageIndex / 4) * 100}%`"
      >
        <updates :project="this.project" @noUpdates="activePageIndex = 1"></updates>
        <about
          :activePageIndex="activePageIndex"
          :isFollowing="isFollowing"
          :project="this.project"
          @toggleFollowProject="handleToggleFollowProject"
          @toggleFollowModal="handleToggleFollowModal"
        ></about>
        <contact
          :activePageIndex="activePageIndex"
          :project="this.project"
          @profilePage="activePageIndex = 3"
        ></contact>
        <profile></profile>
      </div>
    </div>

    <project-send-messages :project="project" v-if="showFollowOptions" @nextStep="handleNextStep" @cancelFollow="handleToggleFollowModal"></project-send-messages>
    <project-user-relationship :project="project" :selectedFollowOptions="selectedFollowOptions" v-if="showFollowConfiguration" @formCompleted="handleFormCompleted"></project-user-relationship>

    <div class="bottom-navigation">
      <div
        class="navigation-item"
        @click="selectPage(0)"
        :class="{ selected: activePageIndex == 0 }"
      >
        <svg
          class="svg-icon"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="tab-icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.6314 8.23285C16.6314 10.5825 14.7782 12.4666 12.467 12.4666C10.1558 12.4666 8.30262 10.5825 8.30262 8.23285C8.30262 5.88227 10.1558 4 12.467 4C14.7782 4 16.6314 5.88227 16.6314 8.23285ZM12.467 20C9.07242 20 6.17391 19.456 6.17391 17.2802C6.17391 15.1034 9.05382 14.5396 12.467 14.5396C15.8616 14.5396 18.7601 15.0836 18.7601 17.2604C18.7601 19.4362 15.8802 20 12.467 20ZM18.411 8.30922C18.411 9.50703 18.0575 10.6229 17.4374 11.5505C17.3737 11.646 17.4303 11.7748 17.5428 11.7946C17.6979 11.8216 17.8582 11.8369 18.0212 11.8414C19.6467 11.8846 21.1057 10.821 21.5088 9.21974C22.1059 6.84123 20.3528 4.7059 18.1204 4.7059C17.8777 4.7059 17.6456 4.73201 17.4197 4.77884C17.3887 4.78605 17.3559 4.80046 17.3382 4.82838C17.317 4.8626 17.3329 4.90853 17.3542 4.93825C18.0248 5.8938 18.411 7.05918 18.411 8.30922ZM21.1031 13.5126C22.1953 13.7296 22.9138 14.1727 23.2114 14.8166C23.463 15.3453 23.463 15.9586 23.2114 16.4864C22.7561 17.4851 21.2882 17.8058 20.7177 17.8886C20.5999 17.9066 20.5051 17.8031 20.5175 17.6833C20.809 14.9157 18.4907 13.6035 17.891 13.3018C17.8653 13.2883 17.86 13.2676 17.8626 13.255C17.8644 13.246 17.875 13.2316 17.8945 13.2289C19.1923 13.2046 20.5875 13.3847 21.1031 13.5126ZM7.01388 11.8413C7.17688 11.8368 7.33633 11.8224 7.49224 11.7945C7.60474 11.7747 7.66144 11.6459 7.59766 11.5504C6.97756 10.6228 6.6241 9.50694 6.6241 8.30913C6.6241 7.05909 7.01034 5.89371 7.68093 4.93816C7.70219 4.90844 7.71725 4.86251 7.69687 4.82829C7.67915 4.80127 7.64549 4.78596 7.61537 4.77875C7.3886 4.73192 7.1565 4.70581 6.91378 4.70581C4.68143 4.70581 2.92833 6.84114 3.52628 9.21965C3.92934 10.8209 5.38834 11.8845 7.01388 11.8413ZM7.172 13.2545C7.17466 13.268 7.16935 13.2878 7.14454 13.3022C6.54394 13.6039 4.22566 14.9161 4.51711 17.6827C4.52951 17.8034 4.43561 17.9061 4.31779 17.889C3.7473 17.8061 2.27944 17.4855 1.82412 16.4867C1.57165 15.9581 1.57165 15.3457 1.82412 14.817C2.12176 14.1731 2.8393 13.73 3.93156 13.512C4.44801 13.385 5.84234 13.2049 7.141 13.2292C7.16049 13.2319 7.17023 13.2464 7.172 13.2545Z"
            fill="currentColor"
          />
        </svg>
        <span>Updates</span>
      </div>
      <div
        class="navigation-item"
        @click="selectPage(1)"
        :class="{ selected: activePageIndex == 1 }"
      >
        <svg
          class="svg-icon"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="tab-icon"
            d="M9.7262 20.7821V17.7152C9.72619 16.9381 10.3514 16.3067 11.1258 16.3018H13.9693C14.7472 16.3018 15.3778 16.9346 15.3778 17.7152V17.7152V20.7732C15.3778 21.4473 15.9197 21.9951 16.5914 22H18.5314C19.4374 22.0023 20.3071 21.6428 20.9486 21.0007C21.5901 20.3586 21.9507 19.4868 21.9507 18.5775V9.86585C21.9506 9.13139 21.6262 8.43471 21.0648 7.9635L14.4743 2.67427C13.3222 1.74912 11.6768 1.77901 10.5589 2.74538L4.11003 7.9635C3.5221 8.42082 3.1707 9.11956 3.15334 9.86585V18.5686C3.15334 20.4637 4.68421 22 6.57264 22H8.46832C8.79172 22.0023 9.10268 21.8751 9.33219 21.6464C9.5617 21.4178 9.69078 21.1067 9.69077 20.7821H9.7262Z"
            fill="currentColor"
          />
        </svg>
        <span>Informatie</span>
      </div>
      <div
        class="navigation-item"
        @click="selectPage(2)"
        :class="{ selected: activePageIndex == 2 }"
      >
        <svg
          class="svg-icon"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="tab-icon"
            d="M21.8388 2.58198C21.3439 2.0686 20.6115 1.87734 19.9286 2.07866L4.0037 6.75952C3.28317 6.96186 2.77246 7.54269 2.63489 8.28055C2.49434 9.0315 2.98525 9.98479 3.62661 10.3834L8.60598 13.4768C9.11669 13.7939 9.77585 13.7144 10.1985 13.2835L15.9004 7.4843C16.1874 7.18231 16.6625 7.18231 16.9495 7.4843C17.2365 7.77623 17.2365 8.24935 16.9495 8.55134L11.2377 14.3516C10.8141 14.7814 10.7349 15.4508 11.0467 15.9702L14.0891 21.0538C14.4454 21.6577 15.0591 22 15.7321 22C15.8113 22 15.9004 22 15.9795 21.9899C16.7515 21.8893 17.3652 21.3558 17.5928 20.6008L22.3139 4.52479C22.5217 3.84028 22.3337 3.09537 21.8388 2.58198Z"
            fill="currentColor"
          />
        </svg>
        <span>Contact</span>
      </div>
      <div
        class="navigation-item"
        @click="selectPage(3)"
        :class="{ selected: activePageIndex == 3 }"
      >
        <svg
          class="svg-icon"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="tab-icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.6314 8.23285C16.6314 10.5825 14.7782 12.4666 12.467 12.4666C10.1558 12.4666 8.30262 10.5825 8.30262 8.23285C8.30262 5.88227 10.1558 4 12.467 4C14.7782 4 16.6314 5.88227 16.6314 8.23285ZM12.467 20C9.07242 20 6.17391 19.456 6.17391 17.2802C6.17391 15.1034 9.05382 14.5396 12.467 14.5396C15.8616 14.5396 18.7601 15.0836 18.7601 17.2604C18.7601 19.4362 15.8802 20 12.467 20ZM18.411 8.30922C18.411 9.50703 18.0575 10.6229 17.4374 11.5505C17.3737 11.646 17.4303 11.7748 17.5428 11.7946C17.6979 11.8216 17.8582 11.8369 18.0212 11.8414C19.6467 11.8846 21.1057 10.821 21.5088 9.21974C22.1059 6.84123 20.3528 4.7059 18.1204 4.7059C17.8777 4.7059 17.6456 4.73201 17.4197 4.77884C17.3887 4.78605 17.3559 4.80046 17.3382 4.82838C17.317 4.8626 17.3329 4.90853 17.3542 4.93825C18.0248 5.8938 18.411 7.05918 18.411 8.30922ZM21.1031 13.5126C22.1953 13.7296 22.9138 14.1727 23.2114 14.8166C23.463 15.3453 23.463 15.9586 23.2114 16.4864C22.7561 17.4851 21.2882 17.8058 20.7177 17.8886C20.5999 17.9066 20.5051 17.8031 20.5175 17.6833C20.809 14.9157 18.4907 13.6035 17.891 13.3018C17.8653 13.2883 17.86 13.2676 17.8626 13.255C17.8644 13.246 17.875 13.2316 17.8945 13.2289C19.1923 13.2046 20.5875 13.3847 21.1031 13.5126ZM7.01388 11.8413C7.17688 11.8368 7.33633 11.8224 7.49224 11.7945C7.60474 11.7747 7.66144 11.6459 7.59766 11.5504C6.97756 10.6228 6.6241 9.50694 6.6241 8.30913C6.6241 7.05909 7.01034 5.89371 7.68093 4.93816C7.70219 4.90844 7.71725 4.86251 7.69687 4.82829C7.67915 4.80127 7.64549 4.78596 7.61537 4.77875C7.3886 4.73192 7.1565 4.70581 6.91378 4.70581C4.68143 4.70581 2.92833 6.84114 3.52628 9.21965C3.92934 10.8209 5.38834 11.8845 7.01388 11.8413ZM7.172 13.2545C7.17466 13.268 7.16935 13.2878 7.14454 13.3022C6.54394 13.6039 4.22566 14.9161 4.51711 17.6827C4.52951 17.8034 4.43561 17.9061 4.31779 17.889C3.7473 17.8061 2.27944 17.4855 1.82412 16.4867C1.57165 15.9581 1.57165 15.3457 1.82412 14.817C2.12176 14.1731 2.8393 13.73 3.93156 13.512C4.44801 13.385 5.84234 13.2049 7.141 13.2292C7.16049 13.2319 7.17023 13.2464 7.172 13.2545Z"
            fill="currentColor"
          />
        </svg>
        <span>Profiel</span>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "vue";

import Updates from "@/views/project/Updates.vue";
import Contact from "@/views/project/Contact.vue";
import About from "@/views/project/About.vue";
import Profile from "@/views/Profile.vue";

import ProjectHeader from "@/components/ProjectHeader.vue";

import ProjectSendMessages from '@/views/ProjectSendMessages.vue';
import ProjectUserRelationship from '@/views/ProjectUserRelationship.vue';

export default defineComponent({
  name: "App",
  components: {
    ProjectHeader,
    Updates,
    Contact,
    About,
    Profile,
    ProjectSendMessages,
    ProjectUserRelationship
  },
  data() {
    return {
      usingApp: false,
      projectId: "",
      project: {},
      loading: true,
      activePageIndex: 0,
      isFollowing: false,
      user: null,
      showFollowOptions: false,
      showFollowConfiguration: false,
      headerHeight: 0
    };
  },
  methods: {
    selectPage(index) {
      this.activePageIndex = index;
      this.showFollowOptions = false;
      this.showFollowConfiguration = false;
    },
    getProject(id) {
      if (!id) return;
      this.$http({
        method: "GET",
        url: `${process.env.VUE_APP_BACKEND_URL}/projects/public/${id}`,
      })
        .then((result) => {
          this.project = result.data;
          this.isFollowing = this.user.projects ? this.user.projects.filter(project => project.following).map(project => project.id).includes(id) : false
          this.calculateHeaderHeight()
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async calculateHeaderHeight() {
      await new Promise(r => setTimeout(r, 1));
      const header = document.getElementById('project-header');
      if(!header) return
      console.log(header.getBoundingClientRect())
      this.headerHeight = header.getBoundingClientRect().height;
    },
    setNavigationOption() {
      const { follow } = this.$route.query;
      if (follow) this.handleToggleFollowModal();
    },
    handleToggleFollowProject() {
      if(!this.isFollowing) return this.handleFollowProject()

      const newProjects = this.user.projects.filter(project => project.id !== this.project.id);
      this.user.projects = newProjects;
      localStorage.setItem('user', JSON.stringify(this.user));
      this.isFollowing = false;
      this.showFollowOptions = false;
    },
    handleFollowProject() {
      this.activePageIndex = 1;
      this.showFollowOptions = true;
    },
    toggleFollowProject() {
      this.isFollowing = true;
    },
    handleToggleFollowModal() {
      if(!this.showFollowOptions) this.handleFollowProject()
      else this.showFollowOptions = false
      console.log(this.showFollowOptions)
    },
    //
    handleNextStep(selectedOptions) {
        this.showFollowOptions = false;
        this.selectedFollowOptions = selectedOptions;
        this.showFollowConfiguration = true;
    },
    handleFormCompleted(userData) {
        const projectIndex = this.user.projects.findIndex(project => project.id == this.project.id)
        if(projectIndex < 0) this.user.projects.push({ ...this.project, following: true, followOptions: this.selectedFollowOptions, chats: [] });
        else this.user.projects[projectIndex].following = true;

        this.user.fullName = userData.fullName;
        this.user.email = userData.email;
        this.user.phone = userData.phone;
        
        localStorage.setItem('user', JSON.stringify(this.user));
        this.showFollowConfiguration = false;
        this.selectedFollowOptions = [];
        this.isFollowing = true;
    },
  },
  computed: {
    activeComponent: function () {
      return this.selectedPage;
    }
  },
  created() {
    const { id } = this.$route.params;
    if (id) this.projectId = id;
    this.getProject(id);

    this.setNavigationOption();

    let user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      user = {
        id: uuidv4(),
        projects: [],
        fullName: "",
        email: "",
        phone: null,
      };
      localStorage.setItem("user", JSON.stringify(user));
    }
    this.user = user;

    var android = navigator.userAgent.match(/Android/i) != null; // Check if using Android
    var iPad = navigator.userAgent.match(/iPad/i) != null; // Check if using an iPad
    var iPhone = navigator.userAgent.match(/iPhone/i) != null;
    if (android || iPad || iPhone) this.usingApp = true;
  },
  mounted() {
    this.calculateHeaderHeight()
  },
  watch: {
    $route: function() {
      const { follow } = this.$route.query;
      if(follow === 'true') this.handleFollowProject()
      else {
          this.showFollowOptions = false;
          this.showFollowConfiguration = false;
      }
    },
  }
});
</script>

<style lang="scss" scoped>
.tabs-page {
  // position: relative;
  // height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;

  .colors-wrapper {
    position: absolute;
    top: 0;
    height: 10px;
    width: 100%;
    display: flex;
    z-index: 10;

    // .color {
    //   position: absolute;
    //   background-color: var(--color);
    //   height: 10px;
    //   width: 0%;
    //   animation: animate-in 1s ease forwards var(--delay);
    // }
    .gradient {
      position: absolute;
      inset: 0;
      inset-inline-end: -40px;
      background-image: linear-gradient(271.15deg, transparent, var(--ion-color-primary) 7.64%, var(--ion-color-primary-light) 90.68%);
      width: 0%;
      animation: slide-in 1s ease forwards;
    }
  }

  .project-header {
    transition: 0.3s ease;

    &.hide {
      margin-top: var(--header-height);
    }
  }

  .viewport {
    flex-grow: 1;
    margin-bottom: 80px;
    overflow: hidden;

    .components-wrapper {
      translate: var(--left-percentage) 0;
      display: flex;
      width: 400%;
      height: 100%;
      transition: 0.3s ease;

      .page {
        width: 100vw;
        height: 100%;
      }
    }
  }
}

.bottom-navigation {
  position: absolute;
  bottom: 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 80px;
  overflow: hidden;
  width: 100%;
  transition: 0.3s ease;
  background-color: #ffffff;
  z-index: 100;
  border-top: 1.5px solid var(--ion-border-color-2);

  .navigation-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .svg-icon {
      color: #aeaeb2;
      scale: 0.9;
      transition: scale 0.25s cubic-bezier(.51,2.5,.45,1.08), color .2s ease;
      transform-origin: bottom;
    }

    span {
      font-weight: 700;
      font-size: 10px;
      line-height: 15px;
      letter-spacing: -0.0041em;
      color: #aeaeb2;
      // margin-top: 2px;
      transition: 0.2s ease;
    }

    &.selected {
      .svg-icon {
        color: var(--ion-color-primary-tint);
        scale: 1.2;
      }

      span {
        color: var(--ion-color-primary-tint);
      }
    }
  }
}

@keyframes loading {
  0% {
    opacity: 1;
    transform: translateX(-100%);
  }
  30% {
    transform: translateX(0%);
  }
  60% {
    transform: translateX(100%);
  }
  99% {
    transform: translateX(100%);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes slide-in {
  0% {
    width: 0%;
  }
  100% {
    width: 110%;
  }
}
</style>
